export function buildItemEditPayload(item) {
  return {
    expected_updated_at: item.updated_at,
    model: item.model,
    part_name: item.part_name,
    description: item.description,
    price: Number(item.price),
    rack_location: item.rack_location,
    low_stock_threshold: Number(item.low_stock_threshold),
    compatible_models: item.compatible_models || [],
  };
}

export function buildItemDeleteConfig(item) {
  return { data: { expected_updated_at: item.updated_at } };
}

export function replaceItemSnapshot(items, savedItem) {
  return items.map((item) => (item.id === savedItem.id ? savedItem : item));
}

const text = (value) => String(value ?? "").trim();
export function normalizeItemDraft(item, warehouseIds = []) {
  const stock = Object.fromEntries(warehouseIds.map((id) => [id, Number(item?.stock?.[id] ?? 0)]));
  return {
    part_number: text(item?.part_number), model: text(item?.model),
    compatible_models: [...(item?.compatible_models || [])].map(text).filter(Boolean),
    part_name: text(item?.part_name), description: text(item?.description),
    price: Number(item?.price || 0), rack_location: text(item?.rack_location),
    low_stock_threshold: Number(item?.low_stock_threshold || 0), stock,
  };
}
